import type {
  AccessRuleInterfaceCreateRequest,
  AccessRuleInterfaceResponse,
  AccessRuleInterfaceUpdateRequest,
} from '@/entities/user/access-rule';

import { Page, PaginationParams } from '@/shared/api/pagination';
import type { AccessRuleBriefDashboardDTOResponse } from '@/entities/user/access-rule';
import type { AxiosRequestConfig } from 'axios';
import { authInstance } from '@/shared/api/api-instances/auth/api-instance';

export class InterfacesApi {
  static getInterfaces(params: PaginationParams, options?: AxiosRequestConfig) {
    return authInstance.get<AccessRuleInterfaceResponse[]>(`/interface/rules`, {
      ...options,
      params,
    });
  }

  static getInterfaceById(rule_id: string, options?: AxiosRequestConfig) {
    return authInstance.get<AccessRuleInterfaceResponse>(
      `/interface/rule/${rule_id}`,
      options,
    );
  }

  static updateInterface(
    rule_id: string,
    payload: AccessRuleInterfaceUpdateRequest,
    options: AxiosRequestConfig = {},
  ) {
    return authInstance.put<AccessRuleInterfaceResponse>(
      `/interface/rule/${rule_id}`,
      payload,
      options,
    );
  }

  static deleteInterface(rule_id: string, options: AxiosRequestConfig = {}) {
    return authInstance.delete(`interface/rule/${rule_id}`, options);
  }

  static createInterface(
    payload: AccessRuleInterfaceCreateRequest,
    options: AxiosRequestConfig = {},
  ) {
    return authInstance.post<AccessRuleInterfaceResponse>(
      `/interface/rule`,
      payload,
      options,
    );
  }

  static getInterfaceActions(options: AxiosRequestConfig = {}) {
    return authInstance.get(`interface/rules/actions`, options);
  }

  static getInterfaceAccesses(options: AxiosRequestConfig = {}) {
    return authInstance.get(`interface/rules/accesses`, options);
  }

  static getRuleListBrief(
    params: PaginationParams,
    options: AxiosRequestConfig = {},
  ) {
    return authInstance.get<Page<AccessRuleBriefDashboardDTOResponse>>(
      `/interface/rules_brief`,
      {
        ...options,
        params,
      },
    );
  }
}